import React from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { Image } from '../Image';

export const IdCard = (props) => {
  return <Image {...props} src={`${config('PUBLIC_IMAGE')}/idcard.png`} />;
};
